"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7331],{

/***/ 17331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Footer": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/logo/styles.ts

var SVG = (0,stitches/* styled */.zo)("svg", {
    display: "block"
});
var Background = (0,stitches/* styled */.zo)("circle", {
    fill: "$primaryFill"
});
var Circle = (0,stitches/* styled */.zo)("circle", {
    fill: "transparent",
    stroke: "$primaryBackground"
});
var G = (0,stitches/* styled */.zo)("g", {
    transformBox: "fill-box",
    transformOrigin: "center",
    transform: "rotate(0deg)"
});
var Path = (0,stitches/* styled */.zo)("path", {
    fill: "$primaryFill"
});

;// CONCATENATED MODULE: ./src/components/logo/index.tsx




var easedTarget = 50; // 0-100%
var easedRotation = 90; // 0-360
var targets = (/* unused pure expression or super */ null && ([
    25,
    50,
    75
]));
var rotations = (/* unused pure expression or super */ null && ([
    0,
    45,
    90,
    135,
    180,
    225
]));
var i = 0;
var Logo = function() {
    var router = useRouter();
    var ref = useRef(null);
    var refG = useRef(null);
    var PI = Math.PI * 10;
    var rafCutoff = 0.001;
    var ease = 10;
    useEffect(function() {
        var raf;
        i += 1;
        var target = targets[i % targets.length]; // Math.random() * 100; // 50
        var rotation = rotations[~~(Math.random() * rotations.length - 1)]; //  Math.random() * 360; // 255
        var update = function() {
            raf = requestAnimationFrame(update);
            easedTarget += (target - easedTarget) / ease;
            easedRotation += (rotation - easedRotation) / ease;
            if (ref.current) {
                ref.current.style.strokeDasharray = "calc(".concat(easedTarget * PI / 100, ") ").concat(PI);
            }
            if (refG.current) {
                refG.current.style.transform = "rotate(".concat(easedRotation, "deg)");
            }
            if (Math.abs(target - easedTarget) < rafCutoff && Math.abs(rotation - easedRotation) < rafCutoff) {
                cancelAnimationFrame(raf);
            }
        };
        raf = requestAnimationFrame(update);
        return function() {
            cancelAnimationFrame(raf);
        };
    }, [
        PI,
        router === null || router === void 0 ? void 0 : router.pathname
    ]);
    return /*#__PURE__*/ _jsxs(Styles.SVG, {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ _jsx(Styles.Background, {
                r: "9.8",
                cx: "10",
                cy: "10",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx(Styles.G, {
                ref: refG,
                children: /*#__PURE__*/ _jsx(Styles.Circle, {
                    ref: ref,
                    r: "5",
                    cx: "10",
                    cy: "10",
                    fill: "transparent",
                    strokeWidth: "10"
                })
            })
        ]
    });
};
function LogoSVG() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG, {
        width: "24",
        viewBox: "0 0 850 799",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                d: "M798.15 168.299C783.276 141.524 764.576 116.024 742.901 91.7992L461.128 373.572L742.901 655.77C764.576 631.545 783.276 605.621 798.15 578.846L593.302 373.572L798.15 168.299Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                d: "M706.776 55.6745C682.551 33.5747 657.052 15.2999 630.277 4.17233e-07L425.004 205.273L219.73 4.17233e-07C192.53 15.2999 167.03 33.5747 142.805 55.6745L425.004 337.447L706.776 55.6745Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                d: "M847.45 326.822H712.301L665.552 373.572L712.301 420.322H847.45C849.15 405.022 850 389.297 850 373.572C850 357.422 849.15 342.122 847.45 326.822Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                d: "M0.00374997 373.574C-0.421246 490.874 41.6534 591.173 124.528 674.048C207.827 757.347 307.701 798.997 425.001 798.572C533.8 798.997 627.724 763.297 707.198 691.898L107.103 91.802C35.2784 170.851 -0.421246 264.775 0.00374997 373.574Z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
;// CONCATENATED MODULE: ./src/components/newsletter/styles.ts

var Form = (0,stitches/* styled */.zo)("form", {
    display: "flex",
    borderRadius: 5,
    height: 39,
    border: "1px solid $colors$primaryBorder",
    "&:hover": {
        border: "1px solid $colors$secondaryBorder"
    },
    input: {
        backgroundColor: "transparent",
        width: "100%",
        border: "none",
        color: "$primaryFill",
        padding: "$space$4",
        borderRadius: 0,
        "&::placeholder": {
            color: "$secondaryFill"
        },
        "&:focus": {
            outline: 0
        },
        "@bp1": {
            fontSize: 14
        }
    },
    button: {
        position: "relative",
        top: -1,
        right: -1,
        flex: "none",
        backgroundColor: "$primaryFill",
        color: "$primaryBackground",
        border: "1px solid $colors$primaryFill",
        cursor: "pointer",
        width: 80,
        height: 39,
        borderRadius: 5,
        "&:focus": {
            outline: 0,
            backgroundColor: "transparent",
            color: "$primaryFill"
        },
        "&:hover": {
            backgroundColor: "transparent",
            color: "$primaryFill"
        }
    },
    "&bp1": {
        input: {
            fontSize: 14
        }
    }
});
var ButtonHolder = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    top: -1,
    right: -1,
    flex: "none",
    border: "1px solid $colors$primaryFill",
    cursor: "pointer",
    width: 80,
    height: 39,
    borderRadius: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

;// CONCATENATED MODULE: ./src/components/newsletter/index.tsx



/* eslint-disable @typescript-eslint/no-explicit-any */ 


var STATUS;
(function(STATUS) {
    STATUS["IDLE"] = "IDLE";
    STATUS["LOADING"] = "LOADING";
    STATUS["SUCCESS"] = "SUCCESS";
    STATUS["ERROR"] = "ERROR";
})(STATUS || (STATUS = {}));
var Newsletter = function(param) {
    var placeholder = param.placeholder, cta = param.cta;
    var domElement = (0,react.useRef)();
    var ref = (0,react.useState)(STATUS.IDLE), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(), message = ref1[0], setMessage = ref1[1];
    var timer = (0,react.useRef)(0);
    var resetForm = function() {
        clearTimeout(timer.current);
        timer.current = window.setTimeout(function() {
            setStatus(STATUS.IDLE);
            setMessage(null);
            domElement.current.value = "";
        }, 3000);
    };
    var subscribeNewsletter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var response, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setStatus(STATUS.LOADING);
                        setMessage(null);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return fetch("/api/subscription/mailing", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: domElement.current.value
                            })
                        });
                    case 6:
                        response = _ctx.sent;
                        if (!(response.status !== 201)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 10;
                        return response.json();
                    case 10:
                        _$error = _ctx.sent.error;
                        setStatus(STATUS.ERROR);
                        setMessage(_$error);
                        resetForm();
                        _ctx.next = 17;
                        break;
                    case 16:
                        {
                            setStatus(STATUS.SUCCESS);
                            setMessage("Email added sucessfully");
                            resetForm();
                        }
                    case 17:
                        _ctx.next = 24;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](3);
                        setStatus(STATUS.ERROR);
                        setMessage(_ctx.t0);
                        resetForm();
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    19
                ]
            ]);
        }));
        return function subscribeNewsletter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                onSubmit: subscribeNewsletter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "newsletter",
                        ref: domElement,
                        type: "email",
                        placeholder: placeholder,
                        required: true,
                        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"
                    }),
                    status === STATUS.LOADING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonHolder, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                            progress: true
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        as: "button",
                        type: "submit",
                        vertical: true,
                        horizontal: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: cta
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                children: [
                    status === STATUS.SUCCESS && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$secondaryFill",
                            fontSize: 13,
                            padding: "$space$5 $space$4"
                        },
                        children: message
                    }),
                    status === STATUS.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                        css: {
                            color: "$red",
                            fontSize: 13,
                            padding: "$space$5 $space$4"
                        },
                        children: message
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/selector-language/styles.ts



var Container = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* SelectStyles */.WK), {
    fontSize: 16,
    height: 32,
    "@bp1": {
        fontSize: 14
    }
}));

;// CONCATENATED MODULE: ./src/components/selector-language/index.tsx






function SelectorLanguage() {
    var router = useRouter();
    var ref = useState(router.locale), defaultValue = ref[0], setDefaultValue = ref[1];
    var handleChangeLanguage = function(nextLocale) {
        router.push(router.route, router.asPath, {
            locale: nextLocale
        });
    };
    useEffect(function() {
        setDefaultValue(router.locale);
    }, [
        router.locale
    ]);
    var list = [
        {
            value: router.defaultLocale || DEFAULT_LOCALE,
            label: "English"
        },
        {
            value: "de",
            label: "Deutsch"
        },
        {
            value: "xx",
            label: "Test"
        }, 
    ];
    return /*#__PURE__*/ _jsx(Styles.Container, {
        children: /*#__PURE__*/ _jsx(Selector, {
            value: defaultValue,
            list: list,
            onChange: handleChangeLanguage,
            variant: "basic"
        })
    });
}

// EXTERNAL MODULE: ./src/components/selector-theme/index.tsx + 1 modules
var selector_theme = __webpack_require__(76469);
;// CONCATENATED MODULE: ./src/components/footer/styles.ts



var Directory = (0,stitches/* styled */.zo)("div", {
    color: "$primaryFill",
    fontFamily: "$DMSans",
    padding: "$space$3 0",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    zIndex: 1,
    "@bp1": {
        padding: "$space$1 0",
        flexDirection: "row"
    }
});
var Group = (0,stitches/* styled */.zo)("div", {
    nav: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "$2"
    },
    a: {
        lineHeight: "1.5rem"
    }
});
var _obj;
var styles_Container = (0,stitches/* styled */.zo)("div", (_obj = {
    backgroundColor: "$primaryBackground",
    color: "$primaryFill",
    minHeight: "$space$1",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column-reverse",
    zIndex: 1
}, (0,_define_property/* default */.Z)(_obj, "& ".concat(index_es/* Box */.xu), {
    margin: "$space$3 0 0 0"
}), (0,_define_property/* default */.Z)(_obj, "p", {
    margin: 0,
    marginLeft: "$space$3",
    color: "$secondaryFill",
    fontSize: 14,
    whiteSpace: "pre-line"
}), (0,_define_property/* default */.Z)(_obj, "@bp1", (0,_define_property/* default */.Z)({
    flexDirection: "row"
}, "& ".concat(index_es/* Box */.xu), {
    margin: 0
})), _obj));

;// CONCATENATED MODULE: ./src/components/footer/index.tsx

/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ 






function Footer() {
    var t = (0,use_intl_esm3/* default */.Z)("footer");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                css: {
                    position: "relative",
                    backgroundColor: "$primaryBackground"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Directory, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    as: "h6",
                                    children: t("resources")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://docs.versum.xyz",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("documentation")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://docs.versum.xyz/faq/materia/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: "Materia"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://docs.versum.xyz/faq/verification/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: "Verification"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://status.versum.xyz",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("status")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    as: "h6",
                                    children: t("community")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://discord.gg/versum",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("discord")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://versumstudios.github.io/legal/code-of-conduct-0.0.0.html",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("code-conduct")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=feature_request.md&title=",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("suggest-feature")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=bug_report.md&title=",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("report-bug")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    as: "h6",
                                    children: t("terms")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://versumstudios.github.io/legal/terms-of-service-0.0.0.html",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("terms")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            as: "a",
                                            variant: "basic",
                                            href: "https://versumstudios.github.io/legal/privacy-policy-0.0.0.html",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            shrink: true,
                                            children: t("privacy")
                                        }),
                                         false && /*#__PURE__*/ 0
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    as: "h6",
                                    children: t("newsletter")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter, {
                                        placeholder: t("newsletter-placeholder"),
                                        cta: t("newsletter-cta")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            vertical: true,
                            horizontal: true,
                            css: {
                                flexDirection: "column-reverse",
                                paddingBottom: "$space$3",
                                "@bp1": {
                                    flexDirection: "unset",
                                    paddingBottom: "unset"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    vertical: true,
                                    horizontal: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoSVG, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                                            children: [
                                                t("rights", {
                                                    year: new Date().getFullYear()
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                 false && /*#__PURE__*/ 0
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            vertical: true,
                            horizontal: true,
                            css: {
                                "&>*": {
                                    marginLeft: "$space$5"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selector_theme/* SelectorTheme */.z, {})
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 76469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ SelectorTheme; },
  "S": function() { return /* binding */ SelectorThemeTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./src/utils/localstorage.ts
var localstorage = __webpack_require__(77164);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/selector-theme/styles.ts



var Container = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({}, "& ".concat(index_es/* SelectStyles */.WK), {
    fontSize: 16,
    height: 32,
    "@bp1": {
        fontSize: 14
    }
}));

;// CONCATENATED MODULE: ./src/components/selector-theme/index.tsx






var SelectorThemeTypes;
(function(SelectorThemeTypes) {
    SelectorThemeTypes["system"] = "system";
    SelectorThemeTypes["dark"] = "dark";
    SelectorThemeTypes["light"] = "light";
})(SelectorThemeTypes || (SelectorThemeTypes = {}));
function SelectorTheme() {
    var t = (0,use_intl_esm3/* default */.Z)("common");
    var ref = (0,react.useState)(SelectorThemeTypes.system), defaultValue = ref[0], setDefaultValue = ref[1];
    var changeTheme = function(theme) {
        (0,localstorage/* setItem */.LS)("--versum-theme", theme);
        setDefaultValue(theme);
        if (theme !== SelectorThemeTypes.system) {
            document.documentElement.dataset.theme = theme;
        } else {
            delete document.documentElement.dataset.theme;
        }
    };
    (0,react.useEffect)(function() {
        setDefaultValue(document.documentElement.dataset.theme || SelectorThemeTypes.system);
    }, []);
    var list = [
        {
            value: SelectorThemeTypes.system,
            label: t("system"),
            icon: "computer"
        },
        {
            value: SelectorThemeTypes.dark,
            label: t("dark"),
            icon: "dark_mode"
        },
        {
            value: SelectorThemeTypes.light,
            label: t("light"),
            icon: "light_mode"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Selector */.Qf, {
            value: defaultValue,
            list: list,
            onChange: changeTheme
        })
    });
}


/***/ }),

/***/ 77164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; }
/* harmony export */ });
/* unused harmony exports getItem, removeItem */
var getItem = function(prop) {
    return localStorage.getItem(prop);
};
var setItem = function(prop, value) {
    localStorage.setItem(prop, value);
    return getItem(prop);
};
var removeItem = function(prop) {
    localStorage.removeItem(prop);
};


/***/ })

}]);